import React, { useState } from "react";
import axios from "axios";
import "./Contact.css";

const Contact = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        title: "",
        message: "" // 修正: 'messege' を 'message' に修正
    });

    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isConfirmed, setIsConfirmed] = useState(false);
    const [status, setStatus] = useState("初期状態"); // 状態メッセージを表示するための追加
    const [contacts, setContacts] = useState([]); // データを格納するための追加
    // const [responseMessage, setResponseMessage] = useState(""); // レスポンスメッセージを表示するための追加
    // const [error, setError] = useState([]); // エラーを格納するための追加

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitted(true);
    };

    // データを取得する関数

    // const fetchContacts = async () => {
    //     try {
    //         const response = await axios.get("http://localhost:8000/api/contacts");
    //         setContacts(response.data);
    //     } catch (err) {
    //         setError("データの取得に失敗しました。");
    //         console.log("エラー:", err);
    //     }
    // }


    // データを送信する関数
    // const sendFormData = async () => {
    //     console.log("送信するデータ:", formData); // データを出力

    //     try {
    //         const response = await axios.post("http://localhost:8000/api/contacts", formData);
    //         if (response.status === 200) {
    //             setStatus("送信成功！");
    //             setFormData({
    //                 name: "",
    //                 email: "",
    //                 title: "",
    //                 message: "",
    //             });
    //             setIsSubmitted(false);
    //             setIsConfirmed(false);
    //         }
    //     } catch (error) {
    //         console.error("送信エラー:", error);
    //         setStatus("送信に失敗しました。");
    //     }
    // };




    // データをクリアする関数

    const clearData = () => {
        setFormData({
            name: "",
            email: "",
            title: "",
            message: ""
        });
        setIsSubmitted(false);
        setIsConfirmed(false);
    };

    if (isSubmitted && isConfirmed) {
        return (
            <div className="contact-thank-you-wrapper">
                <div className="contact-thank-you-contents-wrapper">
                    <h1>Thank you very much!</h1>
                    <h2>Your Message has been sent!</h2>
                    <h3>We'll call back later.</h3>
                    <br />
                    <div className="contact-thank-you-button-wrapper">
                        <div
                            onClick={() => {
                                clearData();
                            }}
                            className="contact-thank-you-button-back hoverable"
                        >
                            戻る
                        </div>
                    </div>
                </div>
            </div>
        );
    } else if (isSubmitted) {
        return (
            <div className="confirm-wrapper">
                <div className="confirm-text">
                    <h2>以下の内容でよろしければ送信ボタンを押してください。</h2>
                </div>
                <div className="confirm-contents-wrapper">
                    <div className="confirm-contents">
                        <div className="confirm-contents-title">お名前</div>
                        <div className="confirm-contents-element">{formData.name}</div>
                    </div>
                    <div className="confirm-contents">
                        <div className="confirm-contents-title">タイトル</div>
                        <div className="confirm-contents-element">{formData.title}</div>
                    </div>
                    <div className="confirm-contents">
                        <div className="confirm-contents-title">メールアドレス</div>
                        <div className="confirm-contents-element">{formData.email}</div>
                    </div>
                    <div className="confirm-contents">
                        <div className="confirm-contents-title">内容</div>
                        <div className="confirm-contents-element">
                            {formData.message.split("\n").map((line, index) => (
                                <p key={index}>{line}</p>
                            ))}</div>
                    </div>






                </div>
                <div className="confirm-button-wrapper">
                    <div
                        className="confirm-button-ok hoverable"
                        onClick={() => {
                            setIsConfirmed(true);
                            sendFormData(); // 送信処理を呼び出し
                        }}
                    >
                        送信
                    </div>
                    <div
                        className="confirm-button-back hoverable"
                        onClick={() => {
                            setIsConfirmed(false);
                            setIsSubmitted(false);
                        }}
                    >
                        戻る
                    </div>
                </div>
            </div>
        );
    } else if (!isSubmitted && !isConfirmed) {
        return (
            <div className="contact-wrapper">
                <div className="contact-form-wrapper">
                    <form  action="https://formspree.io/f/meoqgdno" method="POST">
                        <h1 className="form-title">Contact Form</h1>

                        <div className="form-data-wrapper">
                            <div className="form-name contact-margin">
                                <div>
                                    <label htmlFor="name" className="form-label-name">
                                        お名前
                                    </label>
                                </div>
                                <div>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        // value={formData.name}
                                        onChange={handleChange}
                                        className="form-name-input"
                                        placeholder="お名前を入力してください。"
                                        required
                                    />
                                </div>
                            </div>

                            <div className="formTitle contact-margin">
                                <div>
                                    <label htmlFor="title" className="form-label-title">
                                        タイトル
                                    </label>
                                </div>
                                <div>
                                    <select
                                        id="title"
                                        name="title"
                                        // value={formData.title}
                                        onChange={handleChange}
                                        className="w-full p-2 border rounded-lg"
                                        required
                                    >
                                        <option value="">選択してください</option>
                                        <option value="出演依頼">出演依頼</option>
                                        <option value="制作依頼（音楽コンテンツ）">
                                            制作依頼（音楽コンテンツ）
                                        </option>
                                        <option value="制作依頼（Web）">制作依頼（Web）</option>
                                        <option value="その他のお問い合わせ">
                                            その他のお問合せ
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div className="mb-4 contact-margin">
                                <div>
                                    <label htmlFor="email" className="block mb-1 font-medium">
                                        Eメール
                                    </label>
                                </div>
                                <div>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        // value={formData.email}
                                        onChange={handleChange}
                                        className="w-full p-2 border rounded-lg"
                                        placeholder="メールアドレスを入力してください"
                                        required
                                    />
                                </div>
                            </div>

                            <div className="mb-4 contact-margin">
                                <div>
                                    <label htmlFor="message" className="block mb-1 font-medium">
                                        内容
                                    </label>
                                </div>
                                <div>
                                    <textarea
                                        id="message"
                                        name="message"
                                        // value={formData.message}
                                        onChange={handleChange}
                                        rows="5"
                                        className="w-full p-2 border rounded-lg contact-textarea"
                                        placeholder="お問い合わせ内容を入力してください"
                                        required
                                    ></textarea>
                                </div>
                                <div className="contact-button-wrapper">
                                    <button
                                        type="submit"
                                        className="w-full bg-blue-500 text-white font-bold py-2 px-4 rounded hover:bg-blue-700 contact-button-send hoverable"
                                    >
                                        送信
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
};

export default Contact;
